exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".nomination-event-table__quantity-input[data-v-0b5dd080]{max-width:100px}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/Nominations/NominationEventTable.vue"],"names":[],"mappings":"AACA,yDACE,eAAiB,CAClB","file":"NominationEventTable.vue","sourcesContent":["\n.nomination-event-table__quantity-input[data-v-0b5dd080] {\n  max-width: 100px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0b5dd080","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Nominations/NominationEventTable.vue
// module id = 1405
// module chunks = 15